import Manufacturers from './Manufacturers';

export default Manufacturers;
